var API_DOMAIN = "https://abinayafinance.zentexus.com/api";
//var API_DOMAIN = "http://localhost/abinayafinance25/api";

export default API_DOMAIN;
